import * as base from 'store/bolt/pixels.js';
import Store from 'store/store';

Store.on('LANDING', () => {
	var s = document.createElement( 'script' );
	s.setAttribute( 'src', 'https://cdn.cookielaw.org/opt-out/otCCPAiab.js' );
	s.setAttribute( 'charset', 'UTF-8' );
	s.setAttribute( 'ccpa-opt-out-ids', 'USP' );
	s.setAttribute( 'ccpa-opt-out-geo', 'US' );
	s.setAttribute( 'ccpa-opt-out-lspa', 'false' );
	document.body.appendChild( s );
});